import { requireAnySystemPermission } from '../../../../backend/features/permissions/shared';
export const isOrganizationVisible = ({ orgId, orgNetwork, userState, includeByMembership, includeByPermissions, includeVisible, isSearch, skipCanAccessAll, }) => {
    var _a, _b;
    const canAccessAll = skipCanAccessAll
        ? false
        : requireAnySystemPermission(userState, 'view-invisible-organizations', 'all-organizations-admin');
    const targetOrgPermissions = userState.orgPermissions[orgId];
    const orgIsVisible = (_a = orgNetwork[orgId]) === null || _a === void 0 ? void 0 : _a.visible;
    if (canAccessAll) {
        return true;
    }
    else if (includeVisible && ((_b = orgNetwork[orgId]) === null || _b === void 0 ? void 0 : _b.visible)) {
        return true;
    }
    else if (includeByMembership && !!targetOrgPermissions) {
        return true;
    }
    else if (isSearch && (!!targetOrgPermissions || (!includeByMembership && !includeByPermissions && orgIsVisible))) {
        return true;
    }
    else {
        return !!(includeByPermissions === null || includeByPermissions === void 0 ? void 0 : includeByPermissions.some((permission) => targetOrgPermissions === null || targetOrgPermissions === void 0 ? void 0 : targetOrgPermissions.includes(permission)));
    }
};
